// PO-GST-01 · P2-D1-B · J1 · turn FastAPI `detail` (string | {code,message,...} | validation list)
// into a readable toast string. Codes and HTTP statuses are untouched — display only.
const CODE_TEXT = {
  PO_AMEND_GST_NOT_READY: "GST for this amendment is not resolved — correct the GST inputs before submitting.",
  PO_AMEND_GST_STALE: "GST inputs changed since submission — review and resubmit the amendment.",
  PO_AMEND_FIELD_NOT_ALLOWED: "These fields can be amended only on GST-controlled POs.",
  PO_AMENDMENT_BLOCKED_GRN_POSTED: "Commercial terms locked — GRN has been posted against this PO.",
  PO_LIFECYCLE_BLOCKED_GRN_POSTED: "Commercial terms locked — GRN has been posted against this PO.",
};

export function apiErrorMessage(e, fallback = "Request failed") {
  const d = e?.response?.data?.detail ?? e?.detail;
  if (d == null || d === "") return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    const parts = d.map((x) => (typeof x === "string" ? x : x?.msg || x?.message || "")).filter(Boolean);
    return parts.length ? parts.join("; ") : fallback;
  }
  if (typeof d === "object") {
    const text = CODE_TEXT[d.code] || d.message || fallback;
    const findings = Array.isArray(d.findings)
      ? d.findings.map((f) => f?.message || f?.code).filter(Boolean).slice(0, 3)
      : [];
    const body = findings.length ? `${text} (${findings.join("; ")})` : text;
    return d.code ? `${body} [${d.code}]` : body;
  }
  return String(d);
}
